import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import { ButtonBase } from '@material-ui/core';
import ChatMark from './ChatMark';
import tokens from '../theme/tokens';

// 오른쪽 아래 실시간문의 런처 — 흰 알약 '채팅상담' + 퀴노스 로고 원(채널톡식). 모바일(compact)은 로고 원만.
// 안읽음 배지는 로고 원 위, '새로운 메시지가 도착했습니다' 말풍선 툴팁은 그 위에 뜬다. bottom: 접수 화면의 고정 운임 바 위로 올릴 때 쓴다
export const NEW_MESSAGE_TEXT = '새로운 메시지가 도착했습니다';
export const LAUNCHER_LABEL = '채팅상담';

const MARK = 56;

const useStyles = makeStyles(() => ({
  root: {
    position: 'fixed',
    right: 24,
    zIndex: tokens.zLauncher,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    transition: 'bottom .2s ease',
  },
  wrap: { position: 'relative' },
  pill: {
    display: 'flex',
    alignItems: 'center',
    height: MARK + 8,
    padding: '0 4px 0 22px',
    borderRadius: (MARK + 8) / 2,
    backgroundColor: tokens.surface,
    boxShadow: '0 8px 24px rgba(22, 22, 23, 0.14)',
    color: tokens.ink,
    fontSize: 16,
    fontWeight: 700,
    letterSpacing: -0.6,
    whiteSpace: 'nowrap',
    transition: 'transform .15s ease, box-shadow .15s ease',
    '&:hover': { transform: 'translateY(-2px)', boxShadow: '0 12px 28px rgba(22, 22, 23, 0.18)' },
  },
  pillMark: { marginLeft: 14 },
  compact: {
    width: MARK + 8,
    height: MARK + 8,
    padding: 0,
    justifyContent: 'center',
    borderRadius: (MARK + 8) / 2,
    backgroundColor: tokens.surface,
    boxShadow: '0 8px 24px rgba(22, 22, 23, 0.14)',
    transition: 'transform .15s ease, box-shadow .15s ease',
    '&:hover': { transform: 'translateY(-2px)' },
  },
  badge: {
    position: 'absolute',
    top: -2,
    right: -2,
    minWidth: 22,
    height: 22,
    padding: '0 6px',
    borderRadius: 11,
    border: `2px solid ${tokens.surface}`,
    backgroundColor: tokens.primaryDark,
    color: tokens.surface,
    fontSize: 12,
    fontWeight: 700,
    lineHeight: '18px',
    textAlign: 'center',
  },
  toast: {
    position: 'relative',
    marginBottom: 12,
    padding: '10px 14px',
    borderRadius: 12,
    border: `1px solid ${tokens.primaryLine}`,
    backgroundColor: tokens.surface,
    boxShadow: tokens.cardShadow,
    color: tokens.ink,
    fontSize: 14,
    fontWeight: 700,
    letterSpacing: -0.6,
    whiteSpace: 'nowrap',
    cursor: 'pointer',
    animation: '$rise .22s ease-out',
    '&:after': {
      content: '""',
      position: 'absolute',
      right: 26,
      bottom: -6,
      width: 10,
      height: 10,
      transform: 'rotate(45deg)',
      backgroundColor: tokens.surface,
      borderRight: `1px solid ${tokens.primaryLine}`,
      borderBottom: `1px solid ${tokens.primaryLine}`,
    },
  },
  '@keyframes rise': {
    from: { opacity: 0, transform: 'translateY(6px)' },
    to: { opacity: 1, transform: 'translateY(0)' },
  },
}));

function ChatLauncher({ open, unread = 0, toast = false, compact = false, bottom = 24, onClick, onToastClick }) {
  const cs = useStyles();
  const label = open ? '실시간문의 닫기' : '퀴노스 실시간문의 열기';
  return (
    <div className={cs.root} style={{ bottom }}>
      {toast && !open && (
        <div className={cs.toast} role="status" onClick={onToastClick || onClick}>
          {NEW_MESSAGE_TEXT}
        </div>
      )}
      <div className={cs.wrap}>
        {compact ? (
          <ButtonBase className={cs.compact} onClick={onClick} focusRipple={false} aria-label={label} aria-expanded={open}>
            <ChatMark size={MARK} ring />
          </ButtonBase>
        ) : (
          <ButtonBase className={clsx(cs.pill)} onClick={onClick} focusRipple={false} aria-label={label} aria-expanded={open}>
            {LAUNCHER_LABEL}
            <ChatMark className={cs.pillMark} size={MARK} ring />
          </ButtonBase>
        )}
        {unread > 0 && !open && <span className={cs.badge}>{unread > 99 ? '99+' : unread}</span>}
      </div>
    </div>
  );
}

export default ChatLauncher;
